import { zodResolver } from '@hookform/resolvers/zod';
import {
    EhegattenunterhaltEinkunftAusKapitalvermoegenUndUnbefristeteZusatzrente,
    EinkuenfteAusNebentaetigkeit,
    schemaId,
    SonstigeEinnahme,
} from 'cpool-schemas';
import { z } from 'zod';

import { schemaRequiredAmount } from './requiredAmount.schema';

const schemaAmountAndId = z.object({
    betragMonatlich: schemaRequiredAmount,
    id: schemaId,
});

const schema = EhegattenunterhaltEinkunftAusKapitalvermoegenUndUnbefristeteZusatzrente.omit({
    betragMonatlich: true,
    id: true,
}).and(schemaAmountAndId);

const schemaOtherIncome = SonstigeEinnahme.omit({ betragMonatlich: true, id: true }).and(schemaAmountAndId);

export const schemaIncomeForm = z.object({
    ehegattenunterhalt: z.array(schema),
    einkuenfteAusKapitalvermoegen: z.array(schema),
    einkuenfteAusNebentaetigkeit: z.array(
        EinkuenfteAusNebentaetigkeit.extend({ betragMonatlich: schemaRequiredAmount }),
    ),
    sonstigeEinnahmen: z.array(schemaOtherIncome),
    unbefristeteZusatzrenten: z.array(schema),
});

export type SchemaIncomeForm = z.infer<typeof schemaIncomeForm>;
export const resolverIncomeForm = zodResolver(schemaIncomeForm);
